import { ExtraPromotion, ProductDetailPromotion } from '../types';

export const formatExtraPromotions = (
  extraPromotions: ExtraPromotion[],
  type: string,
): ProductDetailPromotion[] => {
  return extraPromotions.map((promotion) => ({
    promotionType: type,
    benefit: {
      data: promotion,
    },
  }));
};
